import * as yup from "yup";

export const orderBulkUploadValidations = (selectedData: any) => {
  const schema = yup.object().shape({
    company_code: yup
      .number()
      .required("Company Code is required")
      .test(
        "selected-company",
        "Data inconsistent with the company selected.",
        (value) => value == selectedData?.code?.code
      ),

    company_divisioncode: yup
      .number()
      .required("Company Division Code is required"),

    company_counter_code: yup
      .string()
      .required("Company Counter Code is required")
      .trim(),

    stockist_code: yup
      .string()
      .required("Stockist Code is required")
      .trim(),

    po_ref_no: yup
      .string()
      .required("PO Ref No is required")
      .trim(),

    po_date: yup
      .string()
      .required("PO Date is required")
      .trim(),

    po_expiry_date: yup
      .string()
      .required("PO Expiry Date is required")
      .trim(),

    item_code: yup
      .string()
      .required("Item Code is required")
      .trim(),

    quantity: yup
      .number()
      .required("Quantity is required"),
  });

  return schema;
};
